<fgb-navigation-indicator></fgb-navigation-indicator>
<fgb-popup-notification></fgb-popup-notification>

<ng-container *ngIf="!layoutSettings?.mobileNavbar.hidden">
  <fgb-mobile-nav-menu *ifScreenSize="screenType.Mobile"></fgb-mobile-nav-menu>
</ng-container>

<ng-container *ngIf="!layoutSettings?.desktopNavbar.hidden">
  <fgb-nav-bar *ifScreenSize="screenType.Desktop"></fgb-nav-bar>
</ng-container>

<fgbcl-notification-toast></fgbcl-notification-toast>

<div id="main" role="main">
  <router-outlet></router-outlet>
</div>

<div class="sticky d-none">
  <fgb-floating-cart-button></fgb-floating-cart-button>
</div>

<ng-container *ngIf="!layoutSettings?.footer.hidden">
  <fgb-footer></fgb-footer>
</ng-container>
